var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgZip = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 40,
  fill: "currentColor",
  viewBox: "0 0 34 40",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1186FA",
  d: "M23.074 11.67c-.955 0-1.737-.72-1.737-1.6V0H4.34C1.953 0 0 1.8 0 4.001V36c0 2.199 1.953 4 4.34 4h25.32c2.387 0 4.34-1.8 4.34-4.001v-24.33z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DEE7FA",
  d: "M22.949 11.66h11.047L21.348 0v10.181c.061.79.744 1.422 1.6 1.478Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#095FF9",
  d: "M33.997 19.963v-8.248H23.033z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.878 33.054V35H7.184v-1.946zm4.836-4.074H9.906v-1.26h5.81v1.12l-3.878 4.9h4.074L15.73 35H9.822v-1.12zm4.71-3.976v1.582h-1.652v-1.582zm-.028 2.716V35H16.8v-7.28zm1.54 0h1.555v1.008a3.1 3.1 0 0 1 1.022-.91q.588-.322 1.344-.322.77 0 1.344.28.574.266.952.77.392.504.574 1.218.195.7.196 1.568 0 .882-.224 1.61-.225.714-.644 1.232a2.8 2.8 0 0 1-.994.784 3.2 3.2 0 0 1-1.33.266A3.1 3.1 0 0 1 22.583 35q-.56-.225-1.05-.826v3.542h-1.596V27.72Zm1.583 3.766q0 .714.154 1.19.154.462.406.742.266.28.602.392.35.112.728.112.392 0 .728-.14t.588-.448a2.2 2.2 0 0 0 .392-.798q.14-.49.14-1.19 0-.714-.154-1.19-.14-.49-.392-.784a1.3 1.3 0 0 0-.56-.434 1.8 1.8 0 0 0-.672-.126q-.854 0-1.414.56-.546.56-.546 1.764z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgZip);
export default ForwardRef;